var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("core-popup", {
    class: _vm.popup.remove_popup,
    attrs: {
      id: "gp_autotest_remove_resource_popup",
      show: "",
      title: _vm.title,
      "close-icon": true,
    },
    on: { onClickCancel: _vm.onClose },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", [
              _c("div", {
                class: [
                  _vm.popup.message,
                  _vm.hasAssignedToTasks && _vm.canConvertToVirtualResource
                    ? _vm.popup.message_convert
                    : "",
                ],
                domProps: { innerHTML: _vm._s(_vm.message) },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.popup.buttons },
              [
                _vm.hasAssignedToTasks && _vm.canConvertToVirtualResource
                  ? _c("vgp-button", {
                      style: { marginLeft: 16 + "px" },
                      attrs: {
                        type: "secondary",
                        label: _vm.locales(
                          "convert_to_virtual_resource_button"
                        ),
                        small: true,
                        "is-loading": _vm.isConverting,
                      },
                      on: { onClick: _vm.onConvert },
                    })
                  : _c("vgp-button", {
                      attrs: {
                        id: "gp_autotest_remove_resource_popup_btn_cancel",
                        type: "secondary",
                        label: _vm.locales("common_cancel"),
                        small: true,
                        disabled: _vm.isConverting,
                      },
                      on: { onClick: _vm.onClose },
                    }),
                _vm._v(" "),
                _c("vgp-button", {
                  style: { marginLeft: 16 + "px" },
                  attrs: {
                    id: "gp_autotest_remove_resource_popup_btn_delete",
                    type: "destructive",
                    label: _vm.locales("common_delete"),
                    small: true,
                    disabled: _vm.isConverting,
                  },
                  on: { onClick: _vm.onDelete },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }